import React from 'react'
import {Provider} from 'react-redux'
import { MenuItem } from 'react-bootstrap'
import i18n from 'live/services/i18n'
import Store from '../../store'
import timelineContainer from '../containers/timeline-redux-container'
import ButtonSvg from '../../../assets/timeline.svg'

export default class TimelineViewMainHeaderDropdownMenuButtonProvider extends React.Component {

    constructor (props) {
        super(props)
        this.props = props
    }

    render () {
        let TimelineViewMainHeaderDropdownMenuButtonContainer = timelineContainer(TimelineViewMainHeaderDropdownMenuButton)

        return <Provider store={Store}>
            <TimelineViewMainHeaderDropdownMenuButtonContainer {...this.props}/>
        </Provider>
    }

}

type TimelineViewMainHeaderDropdownMenuButtonProps = {
    dashboardId?: number
    publicMode?: boolean
    userTimelineVisible?: boolean
    timelineConfig?: {
        disabled?: boolean
        mode?: string
    }
    saveUserTimelineVisibility?: (dashboardId: number, userTimelineVisible: boolean) => void
}

class TimelineViewMainHeaderDropdownMenuButton extends React.Component<TimelineViewMainHeaderDropdownMenuButtonProps> {

    constructor (props) {
        super(props)
        this.props = props
    }

    render () {
        let { publicMode, userTimelineVisible, timelineConfig, saveUserTimelineVisibility, dashboardId } = this.props
        let { disabled } = timelineConfig

        return <MenuItem
            onClick={() => saveUserTimelineVisibility(dashboardId, !userTimelineVisible)}
            disabled={disabled || publicMode}>
            <i><ButtonSvg width={16} height={16}/></i>
            <span className="title">
                {
                    disabled
                        ? i18n('Timeline')
                        : userTimelineVisible
                            ? i18n('Toggle Timeline off')
                            : i18n('Toggle Timeline on')
                }
            </span>
            {disabled
                ? <span className="subtitle">
                    {i18n('Timeline disabled on this dashboard')}
                </span>
                : null}
        </MenuItem>
    }

}
